<template>
  <b-modal
    id="change-owner-modal"
    ref="changeOwnerModalRef"
    size="sm"
    title="Trocar titular"
    @ok="handleOk"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div style="display: flex; gap: 2rem; width: 100%;">
        <SocialNumberInput style="width: 100%;" v-model="socialNumber" />
      </div>
    </form>
  </b-modal>
</template>

<script>
import { SocialNumberInput } from '../../../ui/inputs';
import { Api } from '../../../vue/api';
const API = new Api();

export default {
  name: 'ChangeOwnerModal',
  data() {
    return {
      socialNumber: '',
      installationId: 0,
    };
  },
  methods: {
    async handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      await this.handleSubmit();
    },
    openModal(installationId) {
      this.installationId = installationId;
      this.$refs.changeOwnerModalRef.show();
    },
    async handleSubmit() {
      if (!this.socialNumber || !this.installationId) {
        this.$bvToast.toast('Preencha todos os campos!', {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        return;
      }
      const { ok, errors } = await API.post('/execute', {
        path: `/installation/change-owner/${this.installationId}`,
        method: 'post',
        data: { socialNumber: this.socialNumber.replace(/[.\-]/g, '') },
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        return;
      }
      this.$refs.changeOwnerModalRef.hide('change-owner-modal');
      this.$emit('getAll');
    },
  },
  components: { SocialNumberInput },
};
</script>
